import {
  PHONE_CONFIG,
  MIN_INTERNATIONAL_PHONE_LENGTH,
  MAX_INTERNATIONAL_PHONE_LENGTH,
  getPhoneConfigForIsd,
} from "constants/phoneConfig";

export const INVALID_PHONE_ERROR = "Please enter a valid mobile number";
export const REQUIRED_ISD_ERROR = "Please select ISD";

export const getMobileNumberValidationErrorMessage = (isdCode) => {
  const config = getPhoneConfigForIsd(isdCode);
  if (!config.startingDigitsDisplay) {
    return INVALID_PHONE_ERROR;
  }

  const article = config.minLength === 8 ? "an" : "a";
  return `Please enter ${article} ${config.minLength}-digit mobile number starting with ${config.startingDigitsDisplay}.`;
};

export const sanitizePhone = (phone) =>
  String(phone || "").replace(/[\s\-()]/g, "");

export const isIsdCodeSelected = (isdCode) =>
  Boolean(String(isdCode ?? "").trim());

export const validateInternationalPhone = (phone, isdCode) => {
  const sanitized = sanitizePhone(phone);

  if (!sanitized) {
    return false;
  }

  if (!isIsdCodeSelected(isdCode)) {
    return false;
  }

  const config = PHONE_CONFIG[isdCode];

  if (config) {
    const regex = new RegExp(`^${config.pattern}$`);
    return (
      regex.test(sanitized) &&
      sanitized.length >= config.minLength &&
      sanitized.length <= config.maxLength
    );
  }

  return (
    /^\d+$/.test(sanitized) &&
    sanitized.length >= MIN_INTERNATIONAL_PHONE_LENGTH &&
    sanitized.length <= MAX_INTERNATIONAL_PHONE_LENGTH
  );
};

export const getPhoneValidationError = (phone, isdCode) => {
  if (!sanitizePhone(phone)) {
    return null;
  }

  if (!isIsdCodeSelected(isdCode)) {
    return REQUIRED_ISD_ERROR;
  }

  return validateInternationalPhone(phone, isdCode)
    ? null
    : getMobileNumberValidationErrorMessage(isdCode);
};

export const formatPhoneWithOptionalIsd = (phoneNumber, isdCode) => {
  const phone = String(phoneNumber ?? "").trim();
  if (!phone) {
    return "";
  }

  const isd = String(isdCode ?? "").trim();
  return isd ? `${isd} ${phone}` : phone;
};
